













import { Vue, Component, Prop } from 'vue-property-decorator';
import { isNewArticle } from '@/utils/dateFormat';

/**
 * 게시글 신규(N) 아이콘 배지
 * 등록일(publishedAt)로부터 노출 기간(기본 +7일) 이내인 경우에만 렌더링한다.
 * 위치/여백 등 배치 스타일은 사용하는 부모 쪽에서 지정한다.
 */
@Component
export default class ArticleNewBadge extends Vue {
  // 게시글 등록일시 (YYYY-MM-DD[ HH:mm:ss])
  @Prop({ default: '' })
  private readonly publishedAt!: string;

  private get isNew(): boolean {
    return isNewArticle(this.publishedAt);
  }
}
